<template>
  <div class="menu">
    <iframe width="100%" src="https://www.jinrih.com/jd-help-miniapp" style="height: 100vh; border: 0; padding-bottom: 50px;"
      frameborder="0" allowfullscreen>
    </iframe>
  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
    }
  },
  props: [],
  mounted() {

  },
  computed: {
    ...mapGetters({
      brandData: 'brandData',
    }),
    updateRec: {
      get () { return this.tempRecord },
      set(value) { this.updateRecord({ record: value }); },
    },
    updateInd: {
      get () { return this.tempIndex },
      set(value) { this.updateIndex({ index: value }); },
    },

  },
  watch: {
    index(val) {
      // console.log(val);
      if (val !== this.orderRecord.length) {
        this.load = true;
        // console.log(true);
      } else if (val === this.orderRecord.length){
        // console.log(false);
        this.load = false;
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,600&display=swap');

  body {
    font: 300 14px/18px Roboto;
    padding-bottom: 100px;
  }

  .menu {
    z-index: 0;
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    max-width: 540px;
    // height: 650px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
</style>

